import styled from "styled-components";

export const ContainerModalEsqueceuSenha = styled.div`
  padding: 3rem 5rem;

  .titulo {
    text-align: center;
    color: ${(props) => props.theme.colors.secondary};
    font-weight: bold;
    margin-bottom: 2rem;
  }

  .texto {
    text-align: center;
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 5rem;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: center;
    align-items: center;
    width: 100%;

    > div {
      width: 100%;
    }
  }
`;

export const Botoes = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4rem;

  .cancelar {
    color: ${(props) => props.theme.colors.tertiary};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    svg {
      fill: ${(props) => props.theme.colors.tertiary};
      transform: rotate(90deg);
    }
  }
`;
